<template>
  <div class="marketing-banner" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
    <MarketingHubAnimatedFolder :hovered="isHovered" />

    <div class="banner-content">
      <div class="banner-body">
        <h3 class="banner-title">Say hello to<br />Marketing Hub 👋</h3>
        <p class="banner-desc">
          Launch campaigns faster with expert marketing insights, AI powered social media content, and newsletters.
        </p>
      </div>

      <button class="banner-cta" @click="emit('cta-click')">
        Try our Marketing Hub
        <ArrowRightTail height="12" width="12" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import MarketingHubAnimatedFolder from './MarketingHubAnimatedFolder.vue'
import ArrowRightTail from './ArrowRightTail.svg?component'

const emit = defineEmits<{
  close: []
  'cta-click': []
}>()

const isHovered = ref(false)
</script>

<style lang="scss" scoped>
.marketing-banner {
  background: #fcedf1;
  border: 2px solid $red-50;
  border-radius: 20px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 18px 28px;

  @include desktop {
    position: absolute;
    bottom: 24px;
    right: 24px;
    width: 280px;
  }

  @include mobile {
    position: relative;
    margin-top: 20px;
    width: 100%;

    .folder {
      position: absolute;
      bottom: 12px;
      left: -50px;
    }
  }
}

.banner-content {
  @include flex-column($spacing-4);
  justify-content: flex-start;

  @include mobile {
    margin-left: min(40vw, 150px);
    gap: $spacing-2;
  }

  .banner-body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .banner-title {
    font-size: 24px;
    font-weight: 700;
    color: $brand-primary;
    line-height: 30px;
    margin: 0;

    @include mobile {
      font-size: $text-base;
      line-height: 24px;
    }
  }

  .banner-desc {
    font-size: 14px;
    color: #435779;
    line-height: 20px;
    margin: 0;
  }

  .banner-cta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 700;
    color: $brand-secondary;
    background: none;
    border: none;
    cursor: pointer;
    white-space: nowrap;
    padding: 0;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
